import React, { Component } from 'react';
import Header from "./Header";

import data from './data-fixes.json';
 
class Technical extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: data,
};
}
  render() {
    return (

<div className="Technical">
<Header>
</Header>   
       
        <h2>Game Fix logs</h2>
        {data.map(item =>
          <div key={item.id}>
            <span> 
            <a href={item.url}>{item.title}</a>
            </span>
           {/* <span>{item.author} </span>
           <span>{item.num_comments} </span>
           <span>{item.points} </span> */}
           </div>)
        } 
</div>
    );
  }
}
 
export default Technical;



// WEBPACK FOOTER //
// ./src/Technical.js